import { SearchMode } from '#pplx/frontend/ask-models/types/search-modes.js';
// Checked in order: the first mode with a keyword in the last five words of the query wins.
// Keywords must be lowercase because matching lowercases the query.
export const SEARCH_MODE_SUGGESTION_KEYWORDS = [
    [SearchMode.RESEARCH, ['research', 'prepare']],
    [
        SearchMode.STUDY,
        [
            'teach me',
            'study',
            'help me learn',
            'step by step',
            'step-by-step',
            'flashcard',
            'quiz',
            'guide',
            'tutor',
            'help me understand',
        ],
    ],
];
//# sourceMappingURL=consts.js.map